/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Components */
import WelcomePageDetail from './WelcomePageDetail';
import WelcomePageDots from './WelcomePageDots';

/* Utils */
import { useImages } from './utils/useImages';

function WelcomePageContainer({ children }) {
  const {
    images,
    showDots,
    length,
    position,
  } = useImages();

  return (
    <div className="dtv-html5-c-welcome-page-container">
      {
        images.map((item) => (
          <WelcomePageDetail
            key={item.image}
            image={item.image}
            title={item.title}
            subtitle={item.subtitle}
            show={item.show}
          />
        ))
      }
      <div className="dtv-html5-c-welcome-page-container__content">
        {children}
      </div>
      <WelcomePageDots showDots={showDots} length={length} position={position} />
    </div>
  );
}

WelcomePageContainer.propTypes = {
  children: PropTypes.node,
};

WelcomePageContainer.defaultProps = {
  children: undefined,
};

export default memo(WelcomePageContainer);
